<template>
  <CreateEventButton>
    <template #trigger>
      <Fob>
        <i class="fa-regular fa-plus w-5 h-5" />
      </Fob>
    </template>
  </CreateEventButton>
</template>

<script setup lang="ts">
import Fob from "@/components/Seranova/Fobs/Fob.vue";
import CreateEventButton from "./CreateEventButton.vue";
</script>

<style scoped></style>
